import React, { useCallback, useContext, useEffect, useState } from "react";
import { Button, Table, Tooltip } from "antd";
import axios from "axios";
import { UserInfo } from "../../../../context";
import {
  // EditOutlined,
  FormOutlined,
  FileSyncOutlined,
  SettingOutlined,
  QrcodeOutlined,
  PercentageOutlined,
} from "@ant-design/icons";
import UpdateSubscription from "./UpdateSubscription";
// import UpdateDuration from "./UpdateDuration";
import UpdateInfo from "./UpdateInfo";
import MerchantConfig from "./MerchantConfig";
import AllowedRFIDCards from "./AllowedRFIDCards";
import CostPerProduct from "./cost/perproduct";
import CostPerTransaction from "./cost/pertransaction";

const MerchantList = () => {
  const [merchantList, setMerchantList] = useState({
    data: [],
    ready: false,
  });
  const tableLayout = "";
  const scroll = {};
  const { userData } = useContext(UserInfo);
  const [selectedData, setSelectedData] = useState(null);
  const [updateSubscription, setUpdateSubscription] = useState(false);
  // const [updateDuration, setUpdateDuration] = useState(false);
  const [updateInfo, setUpdateInfo] = useState(false);
  const [merchantConfig, setMerchantConfig] = useState(false);
  const [merchantRFIDCards, setMerchantRFIDCards] = useState(false);

  const [merchantCostPerProduct, setMerchantCostPerProduct] = useState(false);
  const [merchantCostPerTransaction, setMerchantCostPerTransaction] =
    useState(false);

  const columns = [
    {
      title: "Business Name",
      dataIndex: "business_name",
      render: (text, record) => <p>{text}</p>,
    },
    {
      title: "Registered Name",
      render: (text, record) => (
        <p>
          {text.reg_firstname} {text.reg_lastname}
        </p>
      ),
    },
    {
      title: "Contact #",
      render: (text, record) => <p>{text.reg_contact_no}</p>,
    },
    {
      title: "Email",
      render: (text) => <p>{text.merchantinfouser.email}</p>,
    },
    {
      title: "Subscription",
      render: (text) => <p>{text.merchantinfosubscription.current_plan}</p>,
    },
    {
      title: "Address",
      render: (text, record) => (
        <p
          style={{
            textTransform: "uppercase",
          }}
        >
          {text.reg_street !== null ? `${text.reg_street}, ` : ""}
          {text.reg_barangay !== null ? `${text.reg_barangay}, ` : ""}
          {text.reg_city !== null ? `${text.reg_city}, ` : ""}
          {text.reg_province !== null ? `${text.reg_province}` : ""}
        </p>
      ),
    },
    {
      title: "Allow Production?",
      align: "center",
      render: (text, record) => (
        <p
          style={{
            textTransform: "uppercase",
            color: parseInt(text.is_production) !== 1 ? "red" : "green",
            fontWeight: "bold",
          }}
        >
          {parseInt(text.is_production) !== 1 ? "No" : "Yes"}
        </p>
      ),
    },
    {
      title: "",
      dataIndex: "",
      align: "center",
      render: (text) => (
        <p
          style={{
            width: 145,
            display:
              text.merchantinfosubscription.current_plan === "trial"
                ? "none"
                : "block",
          }}
        >
          {/* <Tooltip title="Update Duration">
            <Button
              type="dashed"
              shape="circle"
              onClick={() => {
                setSelectedData(text);
                setUpdateDuration(true);
              }}
              icon={<EditOutlined />}
              style={{ marginRight: 5 }}
            />
          </Tooltip> */}

          <Tooltip title="Update Subscription">
            <Button
              type="dashed"
              shape="circle"
              onClick={() => {
                setSelectedData(text);
                setUpdateSubscription(true);
              }}
              icon={<FormOutlined />}
              style={{ marginRight: 5 }}
            />
          </Tooltip>

          <Tooltip title="Update Info">
            <Button
              type="dashed"
              shape="circle"
              onClick={() => {
                setSelectedData(text);
                setUpdateInfo(true);
              }}
              icon={<FileSyncOutlined />}
              style={{ marginRight: 5 }}
            />
          </Tooltip>

          <Tooltip title="Set Config">
            <Button
              type="dashed"
              shape="circle"
              onClick={() => {
                setSelectedData(text);
                setMerchantConfig(true);
              }}
              icon={<SettingOutlined />}
              style={{ marginRight: 5 }}
            />
          </Tooltip>

          <Tooltip title="Set Allow RFID">
            <Button
              type="dashed"
              shape="circle"
              onClick={() => {
                setSelectedData(text);
                setMerchantRFIDCards(true);
              }}
              icon={<QrcodeOutlined />}
              style={{ marginRight: 5 }}
            />
          </Tooltip>

          <Tooltip title="Set Cost Per Product">
            <Button
              type="dashed"
              shape="circle"
              onClick={() => {
                setSelectedData(text);
                setMerchantCostPerProduct(true);
              }}
              icon={<PercentageOutlined />}
              // style={{ marginRight: 5 }}
            />
          </Tooltip>

          {/* <Tooltip title="Set Cost Per Transaction">
            <Button
              type="dashed"
              shape="circle"
              onClick={() => {
                setSelectedData(text);
                setMerchantCostPerTransaction(true);
              }}
              icon={<QrcodeOutlined />}
              // style={{ marginRight: 5 }}
            />
          </Tooltip> */}
        </p>
      ),
    },
  ];

  const tableProps = {
    bordered: false,
    // loading,
    size: "medium",
    // expandable,
    showHeader: true,
    scroll,
    tableLayout,
  };

  const tableColumns = columns.map((item) => ({
    ...item,
    ellipsis: false,
  }));

  const getMerchantList = useCallback(() => {
    var params = { user_id: userData.data.id };
    axios
      .get("user/admin/merchant-list", {
        params,
      })
      .then((response) => {
        const data = response.data;
        setMerchantList({ data, ready: true });
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  }, [userData.data.id]);

  useEffect(() => {
    getMerchantList();
  }, [getMerchantList]);

  return (
    <div style={{ overflowX: "auto" }}>
      <Table
        {...tableProps}
        pagination={{
          position: ["bottomCenter"],
        }}
        columns={tableColumns}
        dataSource={merchantList.data.length > 0 ? merchantList.data : []}
        scroll={scroll}
        rowKey={(record) => record.id}
      />

      {/* {updateDuration && (
        <UpdateDuration
          open={updateDuration}
          close={() => setUpdateDuration(false)}
          getMerchantList={() => getMerchantList()}
          selectedData={selectedData}
        />
      )} */}

      {updateSubscription && (
        <UpdateSubscription
          open={updateSubscription}
          close={() => setUpdateSubscription(false)}
          getMerchantList={() => getMerchantList()}
          selectedData={selectedData}
        />
      )}

      {updateInfo && (
        <UpdateInfo
          open={updateInfo}
          close={() => setUpdateInfo(false)}
          getMerchantList={() => getMerchantList()}
          selectedData={selectedData}
        />
      )}

      {merchantConfig && (
        <MerchantConfig
          open={merchantConfig}
          close={() => setMerchantConfig(false)}
          getMerchantList={() => getMerchantList()}
          selectedData={selectedData}
        />
      )}

      {merchantRFIDCards && (
        <AllowedRFIDCards
          open={merchantRFIDCards}
          close={() => setMerchantRFIDCards(false)}
          selectedData={selectedData}
        />
      )}

      {merchantCostPerProduct && (
        <CostPerProduct
          open={merchantCostPerProduct}
          close={() => setMerchantCostPerProduct(false)}
          selectedData={selectedData}
        />
      )}

      {merchantCostPerTransaction && (
        <CostPerTransaction
          open={merchantCostPerTransaction}
          close={() => setMerchantCostPerTransaction(false)}
          selectedData={selectedData}
        />
      )}
    </div>
  );
};

export default MerchantList;
